import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { endpoints } from '@shared/endpoints';

@Injectable({ providedIn: 'root' })
export class GamesService {
    constructor(private http: HttpClient) {}

    fetchPlatforms() {
        return this.http.get<any[]>(endpoints.newGames.children.getPlatforms());
    }

    fetchGames() {
        return this.http.get<any[]>(endpoints.newGames.children.getGames());
    }

    createGame(body: any) {
        return this.http.post<any>(
            endpoints.admin.children.createGames(),
            body
        );
    }

    updateGame(body: any) {
        return this.http.post<any>(endpoints.admin.children.updateGame(), body);
    }

    deleteGame(gameId: string) {
        return this.http.delete<any>(
            `${endpoints.admin.children.deleteGame(gameId)}`
        );
    }
}
